// frontend/src/pages/ColaboradorDashboard/PagosColaborador.js

import React, { useEffect, useState } from 'react';
import './ColaboradorDashboard.css'; // Usar el mismo CSS del dashboard
import './PagosColaborador.css';
import { FaDollarSign, FaCheckCircle, FaFileInvoiceDollar } from 'react-icons/fa';
import { fetchAuth } from '../../utils/api';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default function PagosColaborador() {
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [plantillaPDF, setPlantillaPDF] = useState(null);
  const [plantillaNombre, setPlantillaNombre] = useState('');
  const monthNames = {
    '01': 'Enero', '02': 'Febrero', '03': 'Marzo', '04': 'Abril', '05': 'Mayo', '06': 'Junio',
    '07': 'Julio', '08': 'Agosto', '09': 'Septiembre', '10': 'Octubre', '11': 'Noviembre', '12': 'Diciembre'
  };
  const fmtMonto = (n) => `$ ${Number(n || 0).toLocaleString('es-CL')}`;

  useEffect(() => {
    const loadPagos = async () => {
      try {
        setLoading(true);
        const data = await fetchAuth('/api/colaborador/mis-pagos/');
        setPagos(Array.isArray(data.pagos) ? data.pagos : []);
      } catch (e) {}
      finally { setLoading(false); }
    };
    loadPagos();
  }, []);

  

  useEffect(() => {
    const loadTpl = async () => {
      try {
        const resp = await fetchAuth('/api/admin/plantillas/colaborador/', { rawResponse: true });
        if (resp.ok) {
          const meta = await resp.json();
          if (meta && meta.url) {
            try {
              const r = await fetchAuth(meta.url, { rawResponse: true });
              const b = await r.blob();
              if (String(b.type || '').toLowerCase().includes('pdf')) {
                setPlantillaPDF(b);
                setPlantillaNombre(String(meta.name || ''));
                return;
              }
            } catch {}
          }
        }
        const resp2 = await fetchAuth('/api/admin/plantillas/general/', { rawResponse: true });
        if (resp2.ok) {
          const meta2 = await resp2.json();
          if (meta2 && meta2.url) {
            try {
              const r2 = await fetchAuth(meta2.url, { rawResponse: true });
              const b2 = await r2.blob();
              if (String(b2.type || '').toLowerCase().includes('pdf')) {
                setPlantillaPDF(b2);
                setPlantillaNombre(String(meta2.name || ''));
                return;
              }
            } catch {}
          }
        }
      } catch {}
      const colab = localStorage.getItem('config_plantillas_reportes_colaborador');
      const general = localStorage.getItem('config_plantillas_reportes_general');
      const fallback = localStorage.getItem('reportes_pago_plantilla_pdf');
      const saved = colab || general || fallback;
      if (saved) {
        try {
          const meta = JSON.parse(saved);
          if (meta && meta.dataUrl) {
            fetch(meta.dataUrl).then(r => r.blob()).then(b => {
              setPlantillaPDF(b);
              setPlantillaNombre(String(meta.name || ''));
            }).catch(() => {});
          }
        } catch {}
      }
    };
    loadTpl();
  }, []);

  const handleExportPago = async (p) => {
    try {
      const doc = new jsPDF({ unit: 'pt', format: 'a4' });
      doc.setFontSize(16);
      doc.text('Reporte de Pago', 40, 40);
      doc.setFontSize(11);
      const mesLabel = monthNames[String(p.mes).padStart(2,'0')] || String(p.mes).padStart(2,'0');
      doc.text(`Período: ${mesLabel} ${p.anio}`, 40, 60);

      const head = [[ 'Mes', 'Bruto', 'Retención 14.5%', 'Líquido' ]];
      const body = [[ mesLabel, fmtMonto(p.monto_bruto), fmtMonto(p.retencion), fmtMonto(p.monto_liquido) ]];

      const pageWidth = doc.internal.pageSize.getWidth();
      autoTable(doc, {
        head,
        body,
        startY: plantillaPDF ? 120 : 70,
        styles: {
          fontSize: 8,
          cellPadding: 5,
          lineColor: [226, 232, 240],
          lineWidth: 0.5,
          textColor: [15, 23, 42],
          overflow: 'linebreak'
        },
        headStyles: {
          fillColor: [99, 102, 241],
          textColor: 255,
          fontStyle: 'bold'
        },
        alternateRowStyles: { fillColor: [248, 250, 252] },
        columnStyles: {
          0: { cellWidth: 100 },
          1: { cellWidth: 100, halign: 'right' },
          2: { cellWidth: 120, halign: 'right' },
          3: { cellWidth: 120, halign: 'right' }
        },
        margin: { left: 40, right: 40 },
        tableWidth: pageWidth - 80,
        theme: 'grid'
      });

      const fname = `pago_${p.anio}-${String(p.mes).padStart(2,'0')}.pdf`;
      if (plantillaPDF) {
        try {
          const { PDFDocument } = await import('pdf-lib');
          const contentArrayBuffer = doc.output('arraybuffer');
          const tplArrayBuffer = await plantillaPDF.arrayBuffer();
          const tplDoc = await PDFDocument.load(tplArrayBuffer);
          const contentDoc = await PDFDocument.load(contentArrayBuffer);
          const [embeddedFirst] = await tplDoc.embedPdf(contentArrayBuffer);
          const tplPages = tplDoc.getPages();
          if (tplPages.length > 0) {
            const firstTplPage = tplPages[0];
            const { width, height } = firstTplPage.getSize();
            firstTplPage.drawPage(embeddedFirst, { x: 0, y: 0, width, height });
          }
          const indices = contentDoc.getPageIndices();
          if (indices.length > 1) {
            const rest = await tplDoc.copyPages(contentDoc, indices.slice(1));
            rest.forEach(pg => tplDoc.addPage(pg));
          }
          const mergedBytes = await tplDoc.save();
          const mergedBlob = new Blob([mergedBytes], { type: 'application/pdf' });
          const mergedUrl = URL.createObjectURL(mergedBlob);
          const a = document.createElement('a');
          a.href = mergedUrl;
          a.download = fname;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(mergedUrl), 2000);
        } catch (err) {
          const blob = doc.output('blob');
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fname;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(url), 2000);
        }
      } else {
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fname;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 2000);
      }
    } catch (e) {}
  };

  

  

  return (
    <div className='dashboard-container'>
      <h1>Mis Pagos</h1>
      <p className='dashboard-subtitle'>Consulta tu informe de pago mensual y gestiona tus boletas.</p>
      
      <div className='pagos-content'>
        <div className='pagos-header'>
          <h2><FaFileInvoiceDollar /> Informe de Pago Mensual</h2>
          {!loading && pagos.length === 0 && (<p className='pagos-mes'>Aún no tienes pagos registrados</p>)}
        </div>

        {pagos.map((p, idx) => (
          <div key={idx} className='pago-bloque'>
            <div className='pago-bloque-header'>
              <h3>{monthNames[String(p.mes).padStart(2,'0')] || `Mes ${String(p.mes).padStart(2,'0')}`} {p.anio}</h3>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <button className='btn-exportar' onClick={() => handleExportPago(p)}>Exportar PDF</button>
              </div>
            </div>
            <div className='pagos-summary'>
              <div className='summary-card base'>
                <div className='summary-icon'><FaDollarSign /></div>
                <div className='summary-content'>
                  <h3>{fmtMonto(p.monto_bruto)}</h3>
                  <p>Monto bruto</p>
                </div>
              </div>
              <div className='summary-card total'>
                <div className='summary-icon'><FaCheckCircle /></div>
                <div className='summary-content'>
                  <h3>{fmtMonto(p.monto_liquido)}</h3>
                  <p>Monto líquido</p>
                </div>
              </div>
          </div>
          <div className='pago-detalle'>
              <table>
                <thead>
                  <tr>
                    <th>Mes</th>
                    <th>Bruto</th>
                    <th>Retención 14.5%</th>
                    <th>Líquido</th>
                    <th>Generado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{monthNames[String(p.mes).padStart(2,'0')] || p.mes}</td>
                    <td>{fmtMonto(p.monto_bruto)}</td>
                    <td>{fmtMonto(p.retencion)}</td>
                    <td>{fmtMonto(p.monto_liquido)}</td>
                    <td>{String(p.creado_en || '').split('T')[0]}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
          </div>
        ))}

      

      
    </div>
    </div>
  );
}
